enum SupportedLanguageCode {
  English = "en",
  German = "de",
  French = "fr",
}

export default SupportedLanguageCode;
